import { defineComponent, Component, watch } from 'vue';
import Disciplines from '@/presentation/disciplines/Disciplines.vue';
import App from '@/presentation/App.class';

import { setupComponent } from '@studyportals/vue-platform';
import Suggestions from './suggestions/Suggestions.vue';

export default defineComponent({
	components: {
		Disciplines: Disciplines as Component,
		// SearchingFor: SearchingFor as Component,
		// TabsManager: TabsManager as Component,
		// Programmes: Programmes as Component,
		Suggestions: Suggestions as Component,
	},
	setup: () => {
		const component = new App();
		watch(component.text, component.onTextChange.bind(component));
		return setupComponent(component);
	},
});